if (!customElements.get('gms-stock-status')) customElements.define('gms-stock-status', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.variants = JSON.parse(this.querySelector('script').textContent);
    this.form = document.getElementById(this.dataset.form);
    this.form?.addEventListener('change', () => queueMicrotask(() => this.setVariant(new FormData(this.form).get('id'))), { signal: this.controller.signal });
    this.setVariant(this.dataset.selected);
  }
  setVariant(id) {
    const variant = this.variants?.find(v => String(v.id) === String(id));
    if (!variant) return;
    const state = !variant.available ? 'unavailable' : variant.tracked && variant.quantity > 0 ? 'in_stock' : 'available';
    this.dataset.state = state;
    this.querySelector('[data-stock-label]').textContent = this.dataset[state === 'in_stock' ? 'inStock' : state];
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
});

if (!customElements.get('gms-auto-video')) customElements.define('gms-auto-video', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.video = this.querySelector('video');
    this.button = this.querySelector('button');
    if (!this.video || !this.button) return;
    this.video.muted = true;
    this.video.loop = true;
    this.video.playsInline = true;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.userPaused = this.reducedMotion.matches;
    const label = () => {
      this.button.textContent = this.video.paused ? this.dataset.play : this.dataset.pause;
      this.button.setAttribute('aria-label', this.button.textContent);
    };
    this.video.addEventListener('play', label, options);
    this.video.addEventListener('pause', label, options);
    this.button.addEventListener('click', () => {
      this.userPaused = !this.video.paused;
      if (this.userPaused) this.video.pause();
      else this.video.play().catch(() => { this.video.controls = true; });
    }, options);
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting;
      this.sync();
    }, { threshold: 0.2 });
    this.observer.observe(this);
    document.addEventListener('visibilitychange', () => this.sync(), options);
    this.reducedMotion.addEventListener('change', e => { this.userPaused = e.matches; this.sync(); }, options);
    if (this.userPaused) this.video.pause();
    label();
  }
  sync() {
    if (this.visible && !this.userPaused && !document.hidden) this.video.play().catch(() => { this.video.controls = true; });
    else this.video.pause();
  }
  disconnectedCallback() { this.video?.pause(); this.observer?.disconnect(); this.controller?.abort(); this.controller = null; }
});
